import { startTransition, useEffect, useState, type MouseEvent } from 'react';
import App from './App';
import Landing from './landing/Landing';

function onLanding() {
  return (
    location.pathname === '/' &&
    !new URLSearchParams(location.search).has('page')
  );
}

export default function SiteEntry() {
  const [landing, setLanding] = useState(onLanding);
  useEffect(() => {
    const syncLocation = () => setLanding(onLanding());
    window.addEventListener('popstate', syncLocation);
    return () => window.removeEventListener('popstate', syncLocation);
  }, []);

  const enterApp = (event: MouseEvent<HTMLAnchorElement>) => {
    // Preserve opening in another tab/window and other native link actions.
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    event.preventDefault();
    window.history.pushState(null, '', '/app');
    startTransition(() => setLanding(false));
  };

  return landing ? <Landing onEnterApp={enterApp} /> : <App />;
}
